import React, { useState, useEffect } from 'react';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { Modal, Button } from 'react-bootstrap';

export default function StyledModal(props) {
  const [closed, setClose] = useState(false);

  return (
    <Modal
      size={props.size}
      show={props.show === true && closed === false}
      onHide={props.onClose || null}
    >
      <Modal.Header>
        <Modal.Title>{props.title && props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
      {(props.footerCloseButton || props.footerButtons) && (
        <Modal.Footer>
          {props.footerCloseButton && (
            <Button variant="secondary" onClick={props.onClose || null}>
              Close
            </Button>
          )}
          {props.footerButtons && props.footerButtons}
        </Modal.Footer>
      )}
    </Modal>
  );
}
